import { render, staticRenderFns } from "./inputblock.vue?vue&type=template&id=648a5350&"
import script from "./inputblock.vue?vue&type=script&lang=js&"
export * from "./inputblock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports